import { useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../api/Middleware";
import { DemandeAValider } from "./EspaceValideur.types";

// Charge à la demande les demandes d'une route "validees" ou "refusees" (chaîne de validation terminée).
// La liste chargée est oubliée dès que la route change (autre année, autre agent) et rechargée si besoin.
export default function useDemandesTerminees<T extends DemandeAValider>(route: string, actif: boolean, onErreur: () => void){
    const onErreurRef = useRef(onErreur);
    onErreurRef.current = onErreur;
    const [resultat, setResultat] = useState<{ route: string, demandes: T[] }>();
    const demandes = resultat?.route === route ? resultat.demandes : undefined;
    const chargees = demandes !== undefined;

    useEffect(() => {
        if(!actif || chargees){
            return;
        }
        let courante = true;
        axiosInstance.get<T[]>(route).then((response) => {
            if(courante){
                setResultat({ route, demandes: response.data ?? [] });
            }
        }).catch(() => {
            if(courante){
                onErreurRef.current();
            }
        })
        return () => {
            courante = false;
        };
    }, [actif, chargees, route])

    return demandes;
}
